<div
  class="brn-form__switch"
  [ngClass]="{ 'brn-form__switch--small': size === 'small' }"
  (click)="onClick()"
>
  <span class="switch" [ngClass]="{ active: value }"> </span>
  <p class="label">
    <ng-content></ng-content>
  </p>
</div>
